export function formatPrice({ prefix, unitAmount }: { prefix: string; unitAmount: number }) {
  return `${prefix}${unitAmount.toFixed(2)}`
}
